import * as React from "react";
import { useEffect, useState } from "react";

import { nullElement } from "../../../../TypingUtils";

export interface ErrorHeaderOptions {
    children: React.ReactNode;
    fixed: boolean;
    tid: string | null;
}

let fixedHeaders: string[] = [];

export const VisibleStickyHeader = (props: ErrorHeaderOptions) => {
    const [isHidden, setIsHidden] = useState(false);

    useEffect(() => {
        if (props.fixed && props.tid) {
            if (!fixedHeaders.includes(props.tid)) {
                fixedHeaders.push(props.tid);
            }
            const isNotLastHeader = props.tid !== fixedHeaders.at(-1);
            setIsHidden(isNotLastHeader);
        } else {
            fixedHeaders = fixedHeaders.filter(x => x !== props.tid);
        }
    }, [props.fixed, fixedHeaders.length]);

    return isHidden ? nullElement : <>{props.children}</>;
};
